export enum ComplexEnumFilterListEvents {
  COMPLEX_DROPDOWN_OPEN = 'complexDropdownOpen',
  COMPLEX_DROPDOWN_CLOSE = 'complexDropdownClose',
}
